module.exports = __webpack_public_path__ + "img/soccerboard87.86674a39.jpg";